import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  Navbar, 
  Nav, 
  Container, 
  Button
} from 'react-bootstrap';
import '../../styles/custom-fixes.css';
import { useThemeMode } from '../../ThemeContext';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Typography from '@mui/material/Typography';

// Import new components
import DemoTrail from './DemoTrail';
import ComplianceInfo from './ComplianceInfo';
import HowItWorks from './HowItWorks';
import MobileApps from './MobileApps';
import PlanDetails from './PlanDetails';
import ComplianceTeams from './ComplianceTeams';
import FAQ from './FAQ';
import Footer from './Footer';
import NavDropdown from '../../components/NavDropdown';

// Import logo for header
import LogoSvg from '../../assets/logo.svg';

function Home() {
  const { mode, toggleTheme } = useThemeMode();

  // Initialize theme on component mount
  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  // Navigation dropdown data
  const productItems = [
    { label: 'Audits', href: '#audits' },
    { label: 'Corrective Actions', href: '#corrective-actions' },
    { label: 'Digital Forms & QR', href: '#digital-forms' },
    { label: 'Policy & Procedure Builder', href: '#policy-builder' },
    { label: 'Photo Inspector', href: '#photo-inspector' },
    { label: 'Document Assistant', href: '#document-assistant' },
    { label: 'Registers/Assets', href: '#registers-assets' }
  ];

  const industriesItems = [
    { label: 'Construction', href: '#construction' },
    { label: 'Childcare', href: '#childcare' },
    { label: 'Health', href: '#health' },
    { label: 'NFP', href: '#nfp' },
    { label: 'Local Government', href: '#local-government' }
  ];

  return (
    <div style={{ backgroundColor: mode === 'dark' ? '#111' : '#fff', minHeight: '100vh' }}>
      {/* Header */}
      <Navbar
        expand="lg"
        className={`header-bar py-2 ${mode === 'dark' ? 'bg-dark navbar-dark' : 'bg-white navbar-light'}`}
        style={mode === 'light' ? { backgroundColor: '#fff' } : {}}>
        <Container fluid className="px-3">
          <Navbar.Brand as={Link} to="/" className="header-logo">
            <img src={LogoSvg} alt="Complimate Logo" style={{ height: 50, verticalAlign: 'middle' }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="mainNavbar" />
          <Navbar.Collapse id="mainNavbar">
            <Nav className="mx-auto mb-2 mb-lg-0 header-nav" style={{ gap: 18, fontSize: 18, fontWeight: 200, display: 'flex', alignItems: 'center' }}>
              <NavDropdown label="Product" items={productItems} href="#product" />
              <NavDropdown label="Industries" items={industriesItems} href="#industries" />
              <Nav.Link href="#pricing">Pricing</Nav.Link>
              <Nav.Link as={Link} to="/learning-hub">Learning Hub</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link as={Link} to="/contact-us">Contact</Nav.Link>
            </Nav>
            <IconButton
              onClick={toggleTheme}
              color="inherit"
              sx={{
                ml: 1,
                backgroundColor: mode === 'dark' ? '#222' : '#e0f7f7',
                borderRadius: '999px',
                px: 2.5,
                py: 1,
                transition: 'background 0.2s',
                '&:hover': {
                  backgroundColor: mode === 'dark' ? '#333' : '#b2f5ea',
                },
                boxShadow: mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.15)' : '0 2px 8px rgba(38,195,192,0.10)'
              }}
            >
              <Brightness4Icon />
              <Typography variant="caption" sx={{ ml: 0.5 }}>{mode === 'light' ? 'Dark' : 'Light'}</Typography>
            </IconButton>
            <Button as={Link} to="/login" variant="outline-primary" className="btn-outline-teal ms-lg-3 header-login">Log In</Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content Sections */}
      <DemoTrail />
      <ComplianceInfo />
      <HowItWorks />
      <MobileApps />
      <PlanDetails />
      <ComplianceTeams />
      <FAQ />
      <Footer />
    </div>
  );
}

export default Home;
